// extracted by mini-css-extract-plugin
export default {"container":"CampaignActivityForCampaignsNamespace_container__iJhEq"};